import { eventBus } from 'EventBus/';

export const triggerChannelAdvisor = {
  name: 'trigger-channel-advisor',
  bind: (el, bindings) => {
    el.addEventListener('click', () => {
      eventBus.$emit('open-channel-advisor-modal', bindings.value);
    });
  },
  unbind: (el, bindings) => {
    el.removeEventListener('click', () => {
      eventBus.$emit('open-channel-advisor-modal', bindings.value);
    });
  },
};
